
export default interface CompanyUserCode {
  AccountID: number
  UserFieldType: string
  Code: string
  Description: string
  UserDefinedCodeID: number
  Dependents: number
  ErrorMessage: string

}
export function CreateEmptyCompanyUserCode(): CompanyUserCode {
  const result: CompanyUserCode = {
    AccountID: 0,
    UserFieldType: "",
    Code: "",
    Description: "",
    UserDefinedCodeID: 0,
    Dependents: 0,
    ErrorMessage: ""

  }
  return result
}

export function  CopyCompanyUserCode(src: CompanyUserCode): CompanyUserCode{
  const result = {...src}
  return result

}
export function CopyCompanyUserCodes(src: CompanyUserCode[]): CompanyUserCode[]{
  const result = Array.from(src, item => CopyCompanyUserCode(item))
  return result
}


